export default __webpack_public_path__ + "static/media/about--mobile.dc3173d6.webp";